import { ADD_MD } from './actionTypes';
export function reducer(state = { userAgent: '' }, action) {
    switch (action.type) {
        case ADD_MD:
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}
